































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import UploadOSS from '@/components/upload/index.vue'
import AlbumsApi from '@/api/albums/promotionFrame.ts'

@Component({
  components: {
    UploadOSS,
  },
})
export default class MainPicModal extends Vue {
  @Prop({ type: String, default: '选择图片' })
  title: string
  // 可选数量 -1表示不限制
  @Prop({ type: Number, default: 6 })
  selectNumber: number
  @Prop({ type: String, default: '选择图片' })
  buttonText: string
  // 是否显示图片样式
  @Prop({ type: Boolean, default: false })
  isShowImg: boolean
  // 是否使用行内样式
  @Prop({ type: Boolean, default: true })
  inline: boolean

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true,
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false,
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.showModal = !this.showModal
    this.getImagesList()
  }

  showModal = false
  leftActive = 0
  page = {
    totalCount: 0,
    currentPage: 1,
    skipCount: 0,
    maxResultCount: 40,
  }
  albumsList = [
    {
      name: '模板1',
      value: 1,
    },
    {
      name: '模板2',
      value: 2,
    },
    {
      name: '模板3',
      value: 3,
    },
    {
      name: '模板4',
      value: 4,
    },
  ]
  imgList = []
  selectImgList = []

  get dir() {
    return 'images/' + +new Date()
  }

  created() {}

  showFn() {
    this.showModal = true
    this.getImagesList()
  }

  /**
   * 获取图片列表
   */
  getImagesList() {
    let { maxResultCount, currentPage } = this.page
    AlbumsApi.getPromotionFrameList(currentPage, maxResultCount, this.leftActive + 1).then((res) => {
      if (res.data) {
        // console.log('图片列表', res.data);
        res.data.items.forEach((item) => {
          item['active'] = false
          this.selectImgList.forEach((child) => {
            if (item.id == child.id) {
              item['active'] = true
            }
          })
        })
        this.imgList = res.data.items || []
        this.page.totalCount = res.data.totalCount
      }
    })
  }

  /**
   * 选择左侧模板
   */
  selectAlbumsFn(index) {
    this.leftActive = index
    this.getImagesList()
  }

  /**
   * 选择图片
   */
  selectImgFn(params) {
    let vm = this
    let isHave = vm.selectImgList.some((item) => item.id == params.id)

    if (!isHave && (vm.selectNumber == -1 || vm.selectImgList.length < vm.selectNumber)) {
      params['active'] = true
      vm.selectImgList.push(params)
    } else {
      // 增加只选一张的时候的判断
      if (vm.selectNumber === 1) {
        vm.imgList.forEach((item) => (item['active'] = false))
        params['active'] = true
        vm.selectImgList = [params]
      } else {
        params['active'] = false
        vm.selectImgList.forEach((item, index) => {
          if (item.id == params.id) {
            vm.selectImgList.splice(index, 1)
          }
        })
      }
    }
  }

  /**
   * 给相册添加图片
   */
  uploadChange(event) {
    event.forEach((item, index) => {
      let arr = item.url.split('/')
      let obj = {
        frameType: this.leftActive + 1,
        imageName: arr[arr.length - 1],
        priceX: 0,
        priceY: 0,
        frameUrl: item.url,
      }
      AlbumsApi.uploadPromotionFrame(obj).then((res) => {
        this.$Notice.success({
          desc: '上传成功',
        })
        if(event.length - 1 == index) {
          this.getImagesList()
        }
      })
    })
  }

  /**
   * 清除所选
   */
  clearFn() {
    let vm = this
    vm.selectImgList = []
    vm.imgList.forEach((item) => (item['active'] = false))
  }

  cancelFn() {
    this.page = {
      totalCount: 0,
      currentPage: 1,
      skipCount: 0,
      maxResultCount: 40,
    }
    this.imgList = []
    this.selectImgList = []
  }

  confirmFn() {
    let list = this.selectImgList
    console.log('sdfsf', list);
    if (list.length > 0) {
      this.$emit('picChange', list)
    }
    this.cancelFn()
  }

  changePage(e) {
    this.page.currentPage = e
    this.page.skipCount = this.page.currentPage <= 1 ? 0 : (this.page.currentPage - 1) * this.page.maxResultCount
    this.imgList = []
    this.getImagesList()
  }
  pageSizeChange(e) {
    this.imgList = []
    this.page.maxResultCount = e
    this.getImagesList()
  }
}
